import { ShortUrlSource } from "@/modules/tracking/consts/ShortUrl";

function toParams(
  search: URLSearchParams | string | null | undefined,
): URLSearchParams | null {
  if (typeof search === "string") return new URLSearchParams(search);
  if (search instanceof URLSearchParams) return search;
  return null;
}

export function getShortUrlSource(
  search: URLSearchParams | string | null | undefined,
): ShortUrlSource {
  const raw = toParams(search)?.get("source");
  if (raw === "email" || raw === "sms") {
    return raw;
  }
  return "unknown";
}
